import { Container, Graphics, Text } from '@pixi/react'
import { TextMetrics, TextStyle } from 'pixi.js'
import { memo, useMemo } from 'react'

const textStyle = new TextStyle({
  fill: '#FFFFFF',
  fontSize: 24,
})

export interface IGameNameTagProps {
  x?: number
  y?: number
  name: string
  scale?: number
}

export const GameNameTag = memo((props: IGameNameTagProps) => {
  const textMetrics = useMemo(
    () => TextMetrics.measureText(props.name, textStyle),
    [props.name],
  )

  const backgroundPadding = { x: 10, y: 10 }
  const borderRadius = 8

  return (
    <Container name="GameNameTag" x={props.x ?? 20} y={props.y ?? 1880} scale={props.scale ?? 1}>
      <Graphics
        draw={(g) => {
          g.clear()
          g.beginFill(0x000000, 0.5)
          g.drawRoundedRect(
            -backgroundPadding.x,
            -textMetrics.height / 2 - backgroundPadding.y,
            textMetrics.width + backgroundPadding.x * 2,
            textMetrics.height + backgroundPadding.y * 2,
            borderRadius,
          )
          g.endFill()
        }}
      />
      <Text
        text={props.name}
        anchor={[0.5, 0.5]}
        x={textMetrics.width / 2}
        style={textStyle}
      />
    </Container>
  )
})
